import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";
import { forEach } from "lodash-es";

import { GameAction } from "./game.action";
import { Game, GameState } from "./game.model";

const INITIAL_STATE: GameState = {
	games: {},
	slugs: {},
	gameDetails: {},
	allGamesFetched: false,
	initialGamesFetched: false,
};

export const gameReducer = createReducer(
	INITIAL_STATE,
	on(GameAction.getDetailSuccess, (state, { gameDetail }) =>
		updateState(state, {
			gameDetails: updateState(state.gameDetails, {
				[gameDetail.id]: gameDetail,
			}),
		})
	),
	on(GameAction.fetchAllSuccess, (state, { games }) => {
		const slugs = getSlugs(games);
		return updateState(state, {
			games,
			slugs,
			initialGamesFetched: true,
			allGamesFetched: true,
		});
	}),
	on(GameAction.fetchByCollectionIdSuccess, (state, { games }) => {
		const slugs = getSlugs(games);
		return updateState(state, {
			games,
			slugs,
			initialGamesFetched: true,
		});
	}),
	on(GameAction.getGamesByGameIdsSuccess, (state, { games }) => {
		const slugs = getSlugs(games);
		return updateState(state, {
			games,
			slugs,
			initialGamesFetched: false,
		});
	})
);

const getSlugs = (games: Record<string, Game>): Record<string, string> => {
	const slugs: Record<string, string> = {};
	forEach(games, (game) => (slugs[game.slug] = game.id));
	return slugs;
};
